<template>
  <div class="bg-white border border-blue-200 rounded">
    <div class="flex flex-col">
      <span class="flex-1 bg-blue-200 text-blue-700 text-xs py-1 pl-2"
        >Receiver</span
      >
      <span class="p-1 text-sm text-black font-mono">Ranch Computing</span>
      <span class="flex-1 bg-blue-200 text-blue-700 text-xs p-1">IBAN</span>
      <span class="p-1 text-sm text-black font-mono"
        >FR76 1010 7002 1400 4220 1202 032</span
      >
      <span class="flex-1 bg-blue-200 text-blue-700 text-xs p-1"
        >BIC code (BRED PARIS MIRABEAU)</span
      >
      <span class="p-1 text-sm text-black font-mono">BREDFRPP</span>
    </div>
    <div class="flex flex-row">
      <div class="flex-1 flex flex-col">
        <span class="flex-1 bg-blue-200 text-blue-700 text-xs p-1"
          >Amount: Euro, Cent</span
        >
        <span
          class="flex-1 p-1 text-sm text-black font-mono"
          v-html="amount"
        ></span>
      </div>
      <div class="flex-1 flex flex-col">
        <span class="flex-1 bg-blue-200 text-blue-700 text-xs p-1"
          >Reference</span
        >
        <span class="flex-1 p-1 text-sm text-black font-mono"
          >REFILL #{{ reference }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["amount", "reference", "i18n"],
};
</script>
